export default __webpack_public_path__ + "fonts/example-img2.svg";